import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.spinner = {
    init:function(elt, va, bindings, model, context) {
        var $elt = $(elt);
        var spinconfig = $.extend({"kind":"int"}, ko.utils.unwrapObservable(bindings().spinnerconfig));
        var format = { "int":"d", "decimal":"n", "currency":"C", "percent":"p" }[spinconfig.kind] || "n";
        var options = { numberFormat:format };
        if (spinconfig.min) options.min = spinconfig.min;
        if (spinconfig.max) options.max = spinconfig.max;
        if (spinconfig.step){
            options.step = spinconfig.step;
            if (options["numberFormat"] == "n")
                delete options["numberFormat"];
        }else if (format == "C"){
            options.step = 0.01;
        }
        
        
        if (Globalize.hardcoded_currency && format == "C")
            options["numberFormat"] = "n";
        
        $elt.spinner(options).change(function(ev,ui) { va()($elt.spinner("value")); }).bind("spin", function(ev,ui) {
            var val = ui.value;
            va()(val);
        }).unmousewheel();
        var next = $elt.parent().next(".input-group-btn"), 
            prev = $elt.parent().prev(".input-group-btn"); 
        if (prev.length && next.length ){
            prev.bind("click", function(e){e.preventDefault();$elt.spinner("stepDown", options.step);});
            next.bind("click", function(e){e.preventDefault();$elt.spinner("stepUp", options.step);});
        }
    },
    update: function(elt, va, bindings, model, context) {
        $(elt).spinner("value", ko.unwrap(va()));
    }
};
